export const INVOICE_CARD_ROW_FIELDS = {
  name: { title: 'NOMBRE O RAZÓN SOCIAL', bold: false },
  rfc: { title: 'RFC', bold: false },
};

export const MESSAGE_ZIP_CODE = 'El código postal no es válido';

export const IS_NATURAL = 'natural-person';
export const IS_JURIDICAL = 'juridical-person';
